import React from 'react';
import {
  Row,
  Col,
} from 'antd';
import { SpH5 } from 'components/DesignKit';
import currencyformatter from 'utils/currencyformatter';

type Props = {
  invoiceDetail :{
    vendorName: String,
    invoiceNumber: String,
    totalAmount: Number,
    subTotalAmount: Number,
    invoiceDate: String,
    billedTo: String,
  },
  selectedAccount: Object,
};

const InvoiceDetail = (props: Props) => {
  const {
    invoiceDetail,
    selectedAccount,
  } = props;

  return (
    <Row gutter={16} style={{ backgroundColor: '#F5F5F5', padding: '10px' }}>
      <Col span={12}>
        <Row gutter={16} className="p-1">
          <Col span={24}>
            <SpH5>Vendor Name: {invoiceDetail.vendorName}</SpH5>
          </Col>
        </Row>
        <Row gutter={16} className="p-1">
          <Col span={24}>
            <SpH5>Invoice Number: {invoiceDetail.invoiceNumber}</SpH5>
          </Col>
        </Row>
        <Row gutter={16} className="p-1">
          <Col span={24}>
            <SpH5>Total Amount: {currencyformatter(Number(invoiceDetail.totalAmount) / 100, selectedAccount?.currency?.name)}</SpH5>
          </Col>
        </Row>
      </Col>
      <Col span={12}>
        <Row gutter={16} className="p-1">
          <Col span={24}>
            <SpH5>Billed To: {invoiceDetail.billedTo}</SpH5>
          </Col>
        </Row>
        <Row gutter={16} className="p-1">
          <Col span={24}>
            <SpH5>Invoice Date: {invoiceDetail.invoiceDate}</SpH5>
          </Col>
        </Row>
        <Row gutter={16} className="p-1">
          <Col span={24}>
            <SpH5>Sub Total Amount: {currencyformatter(Number(invoiceDetail.subTotalAmount) / 100, selectedAccount?.currency?.name)}</SpH5>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default InvoiceDetail;
